import { useContext } from "react"
import { CheckIconLaunch } from "../../../../../../../assets/icons/CheckIconLaunch"
import { PendingIcon } from "../../../../../../../assets/icons/PendingIcon"
import { BlockedIcon } from "../../../../../../../assets/icons/BlockedIcon"
import { AlertRegular } from "../../../../../../../assets/icons/AlertRegular"
import intl from "react-intl-universal"
import { fnFormatDateFromUTC } from "../../../../../../../utils/date"
import AuthContext from "../../../../../../../contexts/Auth"

import styles from "./index.module.scss"
import { CONTROL_LEVELS } from "../../../../constants"

const fnTransformDate = (date, cUserTimeZone) => {
  const [data, hour] = fnFormatDateFromUTC(
    `${date}`,
    "DD/MM/YYYY - HH:mm",
    cUserTimeZone,
  ).split(" - ")

  return `${data} - ${hour}`
}

const Table = ({ aTableData, setIsOpen, onClick, selectedHeader, selectedColumn, setSelectedRun  }) => {
  const authContext = useContext(AuthContext)

  if (!aTableData?.length) return null

  const handleCellClick = (columnIndex) => {
    onClick?.(columnIndex)
  }

  const cUserTimeZone = authContext?.oUser?.data?.user_ctimezone

  const rcmpRenderLaunches = (level) => {
    return aTableData.map((run, columnIndex) => {
      const launchesWithELevel2 = run.eqpanltrun_launches?.filter(
        (launch) => launch.eqpanltlaunch_elevel === level,
      )
      if (launchesWithELevel2.length === 0) {
        return (
          <td
            key={`table-analysis-${level}-${columnIndex}`}
            className={
              selectedColumn === columnIndex && level === 3
                ? `${styles.selectedBottom}`
                : selectedColumn === columnIndex && level !== 3
                ? `${styles.selectedBorderInline}`
                : ""
            }
            onClick={() => {
              if (!run.eqpanltrun_number) return
              setSelectedRun?.(run)
              handleCellClick(columnIndex)
            }}
            onDoubleClick={() => {
              setIsOpen?.(true)
            }}
          ></td>
        )
      }
      return launchesWithELevel2.map((launch, index) => {
        return (
          <td
            key={`table-analysis-${run.eqpanltrun_nid}-${level}-${index}`}
            className={`${styles.tooltip} ${
              selectedColumn === columnIndex && level === 3
                ? styles.selectedBottom
                : selectedColumn === columnIndex && level !== 3
                ? styles.selectedBorderInline
                : ""
            } 
            
            ${
              launch.eqpanltlaunch_resultopt_ecompliance === "N"
                ? styles.negative
                : styles.positive
            } ${selectedColumn === columnIndex ? styles.selected : ""}
            `}
            onClick={() => {
              setSelectedRun?.(run)
              handleCellClick(columnIndex)
            }}
            onDoubleClick={() => {
              setIsOpen?.(true)
            }}
          >
            <span>
              {launch?.eqpanltlaunch_user?.cname ? launch?.eqpanltlaunch_user?.cname : ""}
              {launch?.eqpanltlaunch_user?.cname ? <br /> : null}
              {fnTransformDate(launch.eqpanltlaunch_dcreated, cUserTimeZone)}
            </span>
            {launch.eqpanltlaunch_resultopt_cdescription || ""}
          </td>
        )
      })
    })
  }

  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>
              <span></span>
            </th>
            {aTableData.map((item, index) => {
              const cStatus = (letter) => {
                return item.eqpanltrun_status.toLowerCase().startsWith(letter)
              }
              const bParametersChanged = item?.eqpanltrun_parameters_changed
              const cStatusIconsClass = `${styles.column} ${
                bParametersChanged ? styles.alertStatus : ""
              }`
              return (
                <th
                  key={`table-analysis-header-${index}`}
                  style={{ width: "10rem" }}
                  className={`${selectedHeader === index ? styles.selectedth : ""} 
                `}
                  onClick={() => {
                    if (!item.eqpanltrun_number) return
                    setSelectedRun?.(item)
                    handleCellClick(index)
                  }}
                  onDoubleClick={() => {
                    setIsOpen?.(true)
                  }}
                >
                  <div className={styles.iconsAndNumber}>
                    {cStatus("r") && (
                      <div className={cStatusIconsClass}>
                        <small>{intl.get("ciq.status_race.disapproved")}</small>
                        <BlockedIcon width={15} height={15} />
                      </div>
                    )}

                    {cStatus("a") && (
                      <div className={cStatusIconsClass}>
                        <small>{intl.get("ciq.status_race.approved")}</small>
                        <CheckIconLaunch width={15} height={15} />
                      </div>
                    )}

                    {cStatus("p") && (
                      <div className={cStatusIconsClass}>
                        <small>{intl.get("ciq.status_race.pending")}</small>
                        <PendingIcon width={15} height={15} />
                      </div>
                    )}

                    {bParametersChanged && (
                      <div className={styles.column} style={{ left: "calc(50% + 12px)" }}>
                        <small>{intl.get("ciq.status_race.alert")}</small>
                        <AlertRegular />
                      </div>
                    )}

                    <span>{item.eqpanltrun_number}</span>
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {CONTROL_LEVELS.map(({ level, color }) => (
            <tr key={`table-analysis-level-${level}-value`}>
              <td style={{ backgroundColor: color }}>{level}</td>
              {rcmpRenderLaunches(level)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
